import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "./AuthContext";
import { useToast } from "@/components/ui/use-toast";
import { APP_TITLE } from "@/lib/appBranding";

export function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(username, password);

    if (result?.success) {
      try {
        const normalizedUsername = username.trim().toLowerCase();
        localStorage.setItem("last_username", normalizedUsername);
      } catch (_) {
        /* ignore */
      }
      toast({
        title: "Inicio de sesión exitoso",
        description: `Bienvenido a ${APP_TITLE}`,
      });
    } else {
      toast({
        title: "Acceso denegado",
        description: result?.error || "Usuario o contraseña incorrectos",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-orange-50 to-gray-100">
      <div className="header-gradient shadow-md py-6">
        <h1 className="text-3xl font-bold text-white text-center">{APP_TITLE}</h1>
        <p className="text-center text-orange-100 text-sm mt-1">Gestión de fabricación</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-4">
        <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border border-orange-100">
          <h2 className="text-xl font-semibold text-center mb-2 text-gray-800">Iniciar sesión</h2>
          <p className="text-center text-sm text-gray-500 mb-6">Solo usuarios administradores</p>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Usuario</label>
              <Input required value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Contraseña</label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <Button type="submit" className="w-full bg-orange-600 hover:bg-orange-700 text-white">
              Entrar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
